const PrimariesModule = () => import('./PrimariesModule.vue')
import PresidentialPrimariesMap from './views/presidential/PresidentialPrimariesMap.vue'

export const primariesModuleRoute = {
    name: 'primaries',
    path: '/primaries',
    component: PrimariesModule,
    children: [
        {
            path: 'map',
            name: 'primaries.map',
            component: PresidentialPrimariesMap,
            meta: {
                title: 'Presidential Primaries Map',
                requiresAuth: false
            }
        }
    ]
}
